@import '../../style/focus-outline.scss';

:host {
    --wcs-horizontal-step-text-color-default: var(--wcs-semantic-color-text-secondary);
    --wcs-horizontal-step-text-color-active: var(--wcs-semantic-color-foreground-brand);
    --wcs-horizontal-step-text-color-disabled: var(--wcs-semantic-color-text-disabled);


    display: block;

    .steps {
        list-style: none;
        margin: 0;
        padding: 0;

        display: flex;
        flex-direction: row;
        flex: 1;
    }

    .graphic-step {
        display: flex;
        position: relative;
        flex-direction: row;
        flex: 1;
        align-items: center;

        wcs-button {
            z-index: 1;
            mix-blend-mode: darken;
        }
    }

    .graphic-step[data-first] {
        flex: 0;
    }

    wcs-progress-bar {
        --wcs-progress-bar-border-radius: 0;
        flex: 1;
        margin: 0 -1px;
    }

    .label-container {
        justify-content: space-between;
        display: flex;
        flex-direction: row;
        margin-top: var(--wcs-semantic-spacing-base);
    }

    .label-container > * {
        width: 100%;
        text-align: center;
        flex: 1;
        color: var(--wcs-horizontal-step-text-color-default);
        font-weight: 500;

    }

    .label-container > *[data-disable] {
        color: var(--wcs-horizontal-step-text-color-disabled);
    }

    .label-container > *[data-current] {
        color: var(--wcs-horizontal-step-text-color-active);
    }

    .label-container > div[data-first] {
        margin-right: calc(var(--wcs-semantic-size-m, 40px) / 2);
        text-align: left;
        flex: 0.5;
    }

    .label-container > div[data-last] {
        margin-left: calc(var(--wcs-semantic-size-m, 40px) / 2);
        text-align: right;
        flex: 0.5;
    }
}
